import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  toFormatPrice,
  toUnformatPrice,
} from "../../Helper/PriceHelper";
import { LocationsListPricing, TaxsList } from "./masters";

const emptyPricingRow = {};

const handleKeyPress = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
  }
};

/**
 * Owns pricing state so location/tax/price updates do not re-render stone rows
 * in the parent ProductAdvanced page.
 */
const ProductAdvancedPricing = ({ call, initialPricing, valuesRef }) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [formValues_pricing, setFormValues_pricing] = useState([
    emptyPricingRow,
  ]);
  const [formPricetax, setPricetax] = useState("");
  const priceLocationRef = useRef("");
  const setPriceLocationNoRerender = useCallback((value) => {
    priceLocationRef.current = value;
  }, []);

  useEffect(() => {
    if (initialPricing) {
      setFormValues_pricing(initialPricing);
    }
  }, [initialPricing]);

  useEffect(() => {
    if (valuesRef) {
      valuesRef.current = formValues_pricing;
    }
  }, [formValues_pricing, valuesRef]);

  const pricingLocationsKey = formValues_pricing
    .map((e) => e.location || "")
    .join(",");

  const pricing_map_change = (index, key, value) => {
    const index_stone = index;
    const setstatusSelectedOptions = [...formValues_pricing];
    setstatusSelectedOptions[index_stone] = {
      ...setstatusSelectedOptions[index_stone],
    };
    if (value !== undefined) {
      setstatusSelectedOptions[index_stone][key] = value;
    }

    const taxType = setstatusSelectedOptions[index_stone]["taxType"];
    let taxValue = 0;
    const retailValue = toUnformatPrice(
      setstatusSelectedOptions[index_stone]["retailprice_Ex"]
    );
    const retailPlusTaxValue = toUnformatPrice(
      setstatusSelectedOptions[index_stone]["retailprice_Inc"]
    );
    const InvValue = toUnformatPrice(
      setstatusSelectedOptions[index_stone]["inv_retailprice_Ex"]
    );
    const InvPlusTaxValue = toUnformatPrice(
      setstatusSelectedOptions[index_stone]["inv_retailprice_Inc"]
    );
    const taxRate = parseFloat(
      setstatusSelectedOptions[index_stone]["tax_rate_val"]
    );
    if (key === "retailprice_Ex") {
      taxValue = taxType === "Inclusive" ? (retailValue * taxRate) / 100 : 0;
      setstatusSelectedOptions[index_stone]["retailprice_Inc"] = toFormatPrice(
        taxValue + retailValue
      );
      setstatusSelectedOptions[index_stone]["tax"] = toFormatPrice(taxValue);
    } else if (key === "rate") {
      if (retailPlusTaxValue) {
        taxValue =
          taxType === "Inclusive"
            ? (retailPlusTaxValue * taxRate) / (taxRate + 100)
            : 0;
        setstatusSelectedOptions[index_stone]["retailprice_Ex"] = toFormatPrice(
          retailPlusTaxValue - taxValue
        );
      } else {
        taxValue =
          taxType === "Inclusive"
            ? (retailValue * taxRate) / (100 + taxRate)
            : 0;
        setstatusSelectedOptions[index_stone]["retailprice_Inc"] =
          toFormatPrice(taxValue + retailValue);
      }
      setstatusSelectedOptions[index_stone]["tax"] = toFormatPrice(taxValue);
    } else if (key === "retailprice_Inc") {
      taxValue =
        taxType === "Inclusive"
          ? (retailPlusTaxValue * taxRate) / (taxRate + 100)
          : 0;
      setstatusSelectedOptions[index_stone]["retailprice_Ex"] = toFormatPrice(
        retailPlusTaxValue - taxValue
      );
      setstatusSelectedOptions[index_stone]["tax"] = toFormatPrice(taxValue);
    }
    if (key === "inv_retailprice_Ex") {
      taxValue = taxType === "Inclusive" ? (InvValue * taxRate) / 100 : 0;
      setstatusSelectedOptions[index_stone]["inv_retailprice_Inc"] =
        toFormatPrice(taxValue + InvValue);
      setstatusSelectedOptions[index_stone]["tax"] = toFormatPrice(taxValue);
    } else if (key === "rate") {
      if (InvPlusTaxValue) {
        taxValue =
          taxType === "Inclusive"
            ? (InvPlusTaxValue * taxRate) / (taxRate + 100)
            : 0;
        setstatusSelectedOptions[index_stone]["inv_retailprice_Ex"] =
          toFormatPrice(InvPlusTaxValue - taxValue);
      } else {
        taxValue =
          taxType === "Inclusive" ? (InvValue * taxRate) / (100 + taxRate) : 0;
        setstatusSelectedOptions[index_stone]["inv_retailprice_Inc"] =
          toFormatPrice(taxValue + InvValue);
      }
      setstatusSelectedOptions[index_stone]["tax"] = toFormatPrice(taxValue);
    } else if (key === "inv_retailprice_Inc") {
      taxValue =
        taxType === "Inclusive"
          ? (InvPlusTaxValue * taxRate) / (taxRate + 100)
          : 0;
      setstatusSelectedOptions[index_stone]["inv_retailprice_Ex"] =
        toFormatPrice(InvPlusTaxValue - taxValue);
    }
    const incEl = document.querySelector("#retailprice_Inc_" + index_stone);
    const exEl = document.querySelector("#retailprice_Ex_" + index_stone);
    const invIncEl = document.querySelector(
      "#inv_retailprice_Inc" + index_stone
    );
    if (incEl) {
      incEl.value = toFormatPrice(
        setstatusSelectedOptions[index_stone]["retailprice_Inc"]
      );
    }
    if (exEl) {
      exEl.value = toFormatPrice(
        setstatusSelectedOptions[index_stone]["retailprice_Ex"]
      );
    }
    if (invIncEl) {
      invIncEl.value = toFormatPrice(
        setstatusSelectedOptions[index_stone]["inv_retailprice_Inc"]
      );
    }
    setFormValues_pricing(setstatusSelectedOptions);
  };

  useEffect(() => {
    if (formPricetax) {
      pricing_map_change(formPricetax - 1, "rate", 0);
      setPricetax("");
    }
    // eslint-disable-next-line
  }, [formPricetax]);

  const addFormFields_pricing = () => {
    setFormValues_pricing((prev) => [...prev, { ...emptyPricingRow }]);
  };

  const removeFormFields_pricing = (i) => {
    setFormValues_pricing((prev) => {
      const next = [...prev];
      next.splice(i, 1);
      return next;
    });
  };

  return (
    <div className="row  mb-5">
      <h4 className="pro-sub-heading">{t("Pricing")} *</h4>
      <div className="col-md-12">
        <table className="com-product-table">
          <thead>
            <tr>
              <th>{t("Location")}</th>
              <th className="w-12">{t("Currency")}</th>
              <th>{t("Retail price (Ex. Tax)")} </th>
              <th className="w-12">{t("Tax Rate")}</th>
              <th className="w-12">{t("Tax")}</th>
              <th>{t("Retail price (Inc. Tax)")}</th>
              <th>{t("Inventory price (Inc. Tax)")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <>
              {call ? (
                formValues_pricing?.length ? (
                  formValues_pricing.map((element, index) => (
                    <tr key={index}>
                      <td style={{ width: "14%" }}>
                        <LocationsListPricing
                          setPriceLocation={setPriceLocationNoRerender}
                          setPricetax={setPricetax}
                          setstatusSelectedOptions={formValues_pricing}
                          index_stone={index}
                          selected_id={
                            element?.location ? element?.location : "value"
                          }
                          excludeLocationIds={pricingLocationsKey}
                        />
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            value={element.currency}
                            className="h-100"
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            onBlur={(e) => {
                              const formatted = toFormatPrice(e.target.value);
                              e.target.value = formatted;
                              pricing_map_change(
                                index,
                                "retailprice_Ex",
                                formatted
                              );
                            }}
                            defaultValue={element.retailprice_Ex}
                            id={"retailprice_Ex_" + index}
                            className="h-100"
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        <TaxsList
                          setPricetax={setPricetax}
                          setstatusSelectedOptions={formValues_pricing}
                          index_stone={index}
                          selected_id={
                            element?.taxrate ? element?.taxrate : "value"
                          }
                        />
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            value={element?.tax}
                            className="h-100"
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            onBlur={(e) => {
                              const formatted = toFormatPrice(e.target.value);
                              e.target.value = formatted;
                              pricing_map_change(
                                index,
                                "retailprice_Inc",
                                formatted
                              );
                            }}
                            defaultValue={element.retailprice_Inc}
                            id={"retailprice_Inc_" + index}
                            className="h-100"
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="placeholder-up-input w-100">
                          <input
                            onBlur={(e) => {
                              const formatted = toFormatPrice(e.target.value);
                              e.target.value = formatted;
                              pricing_map_change(
                                index,
                                "inv_retailprice_Inc",
                                formatted
                              );
                            }}
                            defaultValue={element.inv_retailprice_Inc}
                            id={"inv_retailprice_Inc" + index}
                            className="h-100"
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      </td>
                      <td>
                        {!index ? (
                          <button
                            type="button"
                            onClick={() => addFormFields_pricing()}
                            className="row-btn ct-disable-btn"
                          >
                            <img
                              src={
                                base_assets + "images/icons/add-detail.png"
                              }
                              alt=""
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => removeFormFields_pricing(index)}
                            className="row-btn ct-disable-btn"
                          >
                            <img
                              src={
                                base_assets + "images/icons/minus-detail.png"
                              }
                              alt=""
                            />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td />
                    <td colSpan="50">
                      <button
                        type="button"
                        onClick={() => addFormFields_pricing()}
                        className="row-btn ct-disable-btn w-100 d-flex align-content-center justify-content-center gap-2"
                      >
                        Add
                        <img
                          src={base_assets + "images/icons/add-detail.png"}
                          alt=""
                        />
                      </button>
                    </td>
                  </tr>
                )
              ) : (
                ""
              )}
            </>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default memo(ProductAdvancedPricing);
